import { getAuthProvider } from "../Auth/authProvider";

export const interceptFetch=async(url, options)=>{
const data=await fetch(url, options)
if(data.status==401){
   const authProvider = getAuthProvider();
        localStorage.clear();
        // localStorage.setItem("login","false")
        authProvider.logout();
  // window.location.reload()
}else{
  return data.json() 
}

  }